
function getFormattedDistance(distance, unit) {
    // The input is km, output is 1 fixed decimal in km or mi
    if (unit === 'km') {
        return distance.toFixed(1)
    } else if (unit === 'mi') {
        return (distance * 0.621371).toFixed(1)
    }
}

function getFormattedDuration(duration) {
    if (Math.floor(duration / 60)) {
        return `${Math.floor(duration / 60)}hrs ${duration % 60}mins`
    } else {
        return `${duration % 60}mins`
    }
}

module.exports = {
    getFormattedDistance,
    getFormattedDuration,
}